"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Time } from "@/helpers/time";
import CommonInput from "../input/CommonInput";
import { CommonSelectItem } from "../select/CommonSelect";
import CommonDropdown from "../select/dropdown/CommonDropdown";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
enum TimeMode {
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  DAYS = "DAYS",
  WEEKS = "WEEKS",
  MONTHS = "MONTHS",
}
const TIME_MODE_LABEL: Record<TimeMode, string> = {
  [TimeMode.MINUTES]: "Minutes",
  [TimeMode.HOURS]: "Hours",
  [TimeMode.DAYS]: "Days",
  [TimeMode.WEEKS]: "Weeks",
  [TimeMode.MONTHS]: "Months"
};
export default function CommonTimeSelect(t0) {
  const $ = _c(44);
  const {
    currentTime,
    onMillis,
    disabled: t1,
    inline: t2,
    size: t3
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const inline = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "md" : t3;
  let t4;
  if ($[0] !== currentTime) {
    t4 = currentTime ? +Time.millis(currentTime).diffFromNow().toHours().toFixed(0) : 0;
    $[0] = currentTime;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const hours = t4;
  const [value, setValue] = useState(hours);
  const [timeMode, setTimeMode] = useState(TimeMode.HOURS);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Object.values(TimeMode).map(_temp);
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const timeModeItems = t5;
  let t6;
  if ($[3] !== timeMode || $[4] !== value) {
    t6 = () => {
      const now = new Date();
      bb20: switch (timeMode) {
        case TimeMode.MINUTES:
          {
            now.setMinutes(now.getMinutes() + value);
            break bb20;
          }
        case TimeMode.HOURS:
          {
            now.setHours(now.getHours() + value);
            break bb20;
          }
        case TimeMode.DAYS:
          {
            now.setDate(now.getDate() + value);
            break bb20;
          }
        case TimeMode.WEEKS:
          {
            now.setDate(now.getDate() + value * 7);
            break bb20;
          }
        case TimeMode.MONTHS:
          {
            now.setMonth(now.getMonth() + value);
            break bb20;
          }
        default:
          {
            assertUnreachable(timeMode);
          }
      }
      return now.getTime();
    };
    $[3] = timeMode;
    $[4] = value;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const getMillis = t6;
  let t7;
  if ($[6] !== getMillis) {
    t7 = () => {
      const millis = getMillis();
      return new Date(millis).toLocaleString();
    };
    $[6] = getMillis;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const getExpiresAt = t7;
  let t8;
  if ($[8] !== getExpiresAt) {
    t8 = getExpiresAt();
    $[8] = getExpiresAt;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const [expiresAt, setExpiresAt] = useState(t8);
  let t9;
  if ($[10] !== getExpiresAt || $[11] !== getMillis || $[12] !== onMillis) {
    t9 = () => {
      onMillis(getMillis());
      setExpiresAt(getExpiresAt());
    };
    $[10] = getExpiresAt;
    $[11] = getMillis;
    $[12] = onMillis;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== timeMode || $[15] !== value) {
    t10 = [value, timeMode];
    $[14] = timeMode;
    $[15] = value;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  useEffect(t9, t10);
  let t11;
  if ($[17] !== value) {
    t11 = value.toString();
    $[17] = value;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = newV => setValue(parseInt(newV ?? "0"));
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== disabled || $[21] !== size || $[22] !== t11) {
    t13 = <div className="tw-w-full lg:tw-w-40"><CommonInput value={t11} inputType="number" disabled={disabled} onChange={t12} placeholder="Time" theme="light" size={size} /></div>;
    $[20] = disabled;
    $[21] = size;
    $[22] = t11;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== disabled || $[25] !== timeMode) {
    t14 = <div className="tw-w-full lg:tw-w-40"><CommonDropdown items={timeModeItems} activeItem={timeMode} disabled={disabled} dynamicPosition={false} filterLabel="Time Mode" theme="light" size="sm" setSelected={setTimeMode} /></div>;
    $[24] = disabled;
    $[25] = timeMode;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-center tw-gap-4 tw-w-full md:tw-w-auto">{t13}{t14}</div>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== disabled || $[31] !== expiresAt || $[32] !== inline) {
    t16 = inline && <div className={`${disabled ? "tw-opacity-50 tw-hidden" : ""}  tw-flex tw-items-center tw-gap-x-1.5`}><svg className="tw-flex-shrink-0 tw-h-4 tw-w-4 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-iron-400 tw-text-xs tw-font-medium tw-space-x-1"><span>Expires At:</span><span className="tw-text-iron-300 tw-font-semibold">{expiresAt}</span></span></div>;
    $[30] = disabled;
    $[31] = expiresAt;
    $[32] = inline;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t15 || $[35] !== t16) {
    t17 = <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-4">{t15}{t16}</div>;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== disabled || $[38] !== expiresAt || $[39] !== inline) {
    t18 = !inline && <div className={`${disabled ? "tw-opacity-50 tw-hidden" : ""}  tw-flex tw-items-center tw-gap-x-1.5`}><svg className="tw-h-4 tw-w-4 tw-text-iron-400" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-iron-400 tw-text-xs tw-font-medium tw-space-x-1"><span>Expires At:</span><span className="tw-text-iron-300 tw-font-semibold">{expiresAt}</span></span></div>;
    $[37] = disabled;
    $[38] = expiresAt;
    $[39] = inline;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17 || $[42] !== t18) {
    t19 = <div className="tw-flex tw-flex-col tw-gap-y-3 tw-w-full">{t17}{t18}</div>;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  return t19;
}
function _temp(mode) {
  return {
    label: TIME_MODE_LABEL[mode],
    value: mode,
    key: mode
  };
}